import ITimeZone from '@/types/ITimeZone';
import { DateTime } from 'luxon';
import { Temporal } from 'temporal-polyfill';

interface IInstant {
	timestamp: string;
	timezone: ITimeZone;
}

interface IInstantConstructorArgs extends IInstant { }

export function createInstant(args: IInstantConstructorArgs) {
	return DateTime.fromISO(args.timestamp, { zone: args.timezone });
}

interface IGetStartOfTheNextDayArgs extends IInstant { }

export function getStartOfTheNextDay(args: IGetStartOfTheNextDayArgs) {
	return DateTime.fromISO(args.timestamp, { zone: args.timezone }).plus({ days: 1 }).startOf('day');
}

export function getStartOfThePrevDay(args: IGetStartOfTheNextDayArgs) {
	return DateTime.fromISO(args.timestamp, { zone: args.timezone }).minus({ days: 1 }).startOf('day');
}

export function getDateString(args: IInstant): string {
	return DateTime.fromISO(args.timestamp, { zone: args.timezone }).toISODate()!;
}


/**
 * TODO: Find a method to properly compute this.
 */
export function getZonedDateTimeFromLocaleString(localeString: string, timeZone: string): Temporal.ZonedDateTime {
	try {

		const original = Temporal.PlainDateTime.from(localeString);

		return Temporal.ZonedDateTime.from({
			year: original.year,
			month: original.month,
			day: original.day,
			hour: original.hour,
			minute: original.minute,
			timeZone: timeZone,
		});
	}
	catch (err) {
		return Temporal.Instant.from(localeString).toZonedDateTime({ timeZone, calendar: 'iso8601' });
	}
}
